module.exports = __webpack_public_path__ + "media/images/signature@2x-2ecb259fb230ef8c2ccbc76038e9eea7.png";